/*
 * cart-bundle-add.js
 * Adds a fixed quantity of one product to the cart in a single click, then
 * asks the cart drawer to re-render. Used by the "Add 3" button rendered by
 * snippets/bundle-offer.liquid, on the cross-sell cards and on the PDP.
 *
 * The saving itself comes from the automatic discount configured in Shopify,
 * not from this script: the button only puts the right quantity in the cart.
 */
class BundleAdd extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button || this.bound) return;
    this.bound = true;
    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.addToCart();
    });
  }

  get root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  async addToCart() {
    const id = Number(this.dataset.variantId);
    const quantity = parseInt(this.dataset.quantity || '3', 10);
    if (!id || !quantity) return;

    this.button.setAttribute('disabled', '');

    try {
      const response = await fetch(`${this.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity }] }),
      });

      if (!response.ok) throw new Error(`cart/add.js responded ${response.status}`);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-bundle-add' });
      }

      document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));

      if (this.dataset.openDrawer === 'true') this.openDrawer();
    } catch (error) {
      console.error('[cart-bundle-add]', error);
      this.button.removeAttribute('disabled');
    }
  }

  openDrawer() {
    // The refresh above only re-renders the drawer, it does not open it.
    // Give it a moment to swap in the new contents, then use the theme's own
    // trigger so focus handling and the overlay behave as they normally do.
    window.setTimeout(() => {
      if (document.querySelector('.wt-cart__drawer--open')) return;
      const trigger = document.querySelector('.wt-cart__trigger');
      if (trigger) trigger.click();
    }, 350);
  }
}

if (!customElements.get('bundle-add')) {
  customElements.define('bundle-add', BundleAdd);
}
